<template>
  <div class="section" style="padding: 10px 0 0 20px">
    <el-form label-position="left" label-width="80px">
      <el-form-item label="国际化转换">
        <div style="width: 450px;float: left;margin-right: 5px;">
          <label style="color: #1890ff">编码：</label>
          <span style="margin-left: 40px;">格式化显示&nbsp;</span>
          <el-select v-model="formatStr" style="width: 170px;">
            <el-option value="{code}" />
            <el-option value="$t('{code}')" />
            <el-option value="this.$t('{code}')" />
            <el-option value="this.view.$t('{code}')" />
            <el-option value="this._view.$t('{code}')" />
            <el-option value="lang.t('{code}')" />
          </el-select>
          <el-button type="primary" style="float: right;" @click="chineseName=$t(code)">转换编码</el-button>
        </div>
        <div style="width: 170px;float: left;">
          <label style="color: #1890ff">中文名：</label>
          <el-button
            type="primary"
            style="float: right;"
            @click="toCode"
          >转换中文名</el-button>
        </div>
      </el-form-item>
      <el-form-item>
        <el-input
          v-model="code"
          type="textarea"
          :rows="10"
          style="width: 450px;margin-right: 5px;"
        />
        <el-input v-model="chineseName" type="textarea" :rows="10" style="width: 170px;" />
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import zhLocale from '@/lang/zh'

export default {
  name: 'LangTools',
  data() {
    return {
      code: '',
      chineseName: '',
      formatStr: '{code}'
    }
  },
  created() {
    this.zhLocaleReverse = this.reverseKeyValue(zhLocale)
  },
  methods: {
    reverseKeyValue(obj, keyPath = '', result = {}) {
      for (const key in obj) {
        const val = obj[key]
        if (!val) {
          continue
        }
        if (typeof val === 'string') {
          if (result[val]) {
            result[val] += '\n'
          } else {
            result[val] = ''
          }
          result[val] += `${keyPath}${key}`
        } else if (val instanceof Object && !(val instanceof Array)) {
          this.reverseKeyValue(val, keyPath + key + '.', result)
        }
      }
      return result
    },
    toCode() {
      const lines = (this.zhLocaleReverse[this.chineseName] || this.chineseName).split('\n')
      const newLines = []
      for (let line of lines) {
        if (line) {
          line = this.formatStr.replace('{code}', line)
        }
        newLines.push(line)
      }
      this.code = newLines.join('\n')
    }
  }
}
</script>
